import {Space, Spin} from "antd";
import {LoadingSpinner} from "../../../icons/icons";
import {StyledNoUpcomingCallBox} from "../../upcoming-calls/upcoming-calls.style";
import {CustomPagination} from "../../../pagination";
import {useGetCustomerPastCallsContext} from "../../../../context/past-calls/customer";
import {CustomerPastCallCard} from "../past-call-card/customer";

const CustomerPastCallsComponent = () => {
  const {
    state: {
      customerPastCallsData: {bookings},
      customerPastCallsApiMetaResponse,
      isPreviousCustomerPastCallsData,
      isFetchingCustomerPastCalls,
      page,
      setPage,
    },
  } = useGetCustomerPastCallsContext();

  return (
    <>
      {bookings.length > 0 ? (
        <Spin
          spinning={isFetchingCustomerPastCalls}
          tip="Updating..."
          indicator={LoadingSpinner}
        >
          <div>
            <Space
              direction="vertical"
              size={42}
              style={{
                display: "flex",
              }}
            >
              {bookings.map((pastCall) => {
                if (pastCall.service) {
                  return <CustomerPastCallCard key={pastCall.id} session={pastCall} />;
                } else {
                  return <p>Session does not exist</p>;
                }
              })}
            </Space>
            <CustomPagination
              isPreviousData={isPreviousCustomerPastCallsData}
              page={page}
              paginationMeta={customerPastCallsApiMetaResponse}
              setPage={setPage}
            />
          </div>
        </Spin>
      ) : (
        <Spin
          spinning={isFetchingCustomerPastCalls}
          tip="Updating..."
          indicator={LoadingSpinner}
        >
          <StyledNoUpcomingCallBox>
            <p className="info-text">You do not have past sessions at the moment.</p>
          </StyledNoUpcomingCallBox>
        </Spin>
      )}
    </>
  );
};

export {CustomerPastCallsComponent};
